var render = function render(_c,_vm){return _c('span',{staticClass:"xl:text-xl 2xl:text-2xl"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }